import ShopCardComponent from 'draft/cards/shopCardComponent';
import { useMeleeContext } from 'draft/context/MeleeContextProvider';
import PlayerDraftCard from 'draft/playerDraftCard';
import { ActionType, Team } from 'draft/types';
import { AnotherOneFFA, BanFiestaFFA, SneakFFA, StageWarp } from 'draft/utils/cardEvents';
import { AddToHistory } from 'draft/utils/roundHandler';
import React from 'react'
import { Card, Grid } from 'semantic-ui-react';
import FFAHeroImage from './ffaHeroButton';

type Props = {
  executeAction: any,
  applyHeroAction: any,
  addPlayerToSelection: any

  setCurrentAction: any,
  setCardPurchased: any,
  addActionToSequence: any
}

const FFABody = (
  {
    executeAction,
    applyHeroAction,
    addPlayerToSelection,
    setCurrentAction,
  }: Props) => {
  const meleeContext = useMeleeContext();
  if (!meleeContext || !meleeContext.players) return <></>

  const currentAction = meleeContext.gameData.CurrentAction;

  const purchaseCard = (effects: string[]): void => {
    AddToHistory(meleeContext.gameData)
    const buyingPerson = currentAction?.PlayerNumber;

    const effect = effects[0];
    switch (effect) {
      case 'addBan':
        setCurrentAction(ActionType.Ban, Team.Blue, buyingPerson);
        break;
      case 'stageWarp':
        meleeContext.setGameData(StageWarp(meleeContext.gameData, meleeContext.draftOptions.stagePack));
        executeAction();
        break;
      case 'banFiesta':
        meleeContext.setGameData(BanFiestaFFA(meleeContext.gameData))
        executeAction();
        break;
      case 'sneak':
        meleeContext.setGameData(SneakFFA(meleeContext.gameData));
        executeAction();
        break;
      case 'anotherOne':
        meleeContext.setGameData(AnotherOneFFA(meleeContext.gameData));
        executeAction();
        break;
      default:
        throw new Error(`Card Effect failed: ${effect} is not implemented or does not exist`);
    }
  }

  const HeroPoolSection = () => {
    if (!meleeContext.gameData.CommonHeroes) throw new Error("Common hero pool is missing - this is FFA!!");
    return (
      <div style={{ textAlign: 'center' }}>
        <h3>Hero Pool</h3>
        <Grid columns={3} centered className='hero-pool-container' style={{ margin: "16px 16px 32px 16px" }}>
          {meleeContext.gameData.CommonHeroes.map(row => (
            <Grid.Row>
              {row.map(hero => (
                <Grid.Column style={{ textAlign: 'center' }}>
                  <FFAHeroImage
                    executeAction={executeAction}
                    applyHeroAction={applyHeroAction}
                    hero={hero}
                  />
                </Grid.Column>
              ))}
            </Grid.Row>
          ))}
        </Grid>
      </div>
    )
  }

  const CardTable = () => (
    <Card.Group centered itemsPerRow={3} stackable>
      {meleeContext.gameData.ShopCards.map(c => {
        var action = currentAction ? currentAction : undefined;
        return (
          <ShopCardComponent
            card={c}
            purchaseCard={purchaseCard}
            currentAction={action?.Action}
            key={`shop-card-${c.Index}`}
          />
        )
      }
      )}
    </Card.Group>
  )


  return (
    <>
      <Grid columns='equal' centered relaxed stackable>
        <Grid.Column>
          {meleeContext.players.map((_, i) =>
            <div style={{ margin: '3.5em 0px 3.5em 0px', maxWidth: '32.5em' }}>
              <PlayerDraftCard
                player={meleeContext.gameData.Players[i]}
                currentAction={meleeContext.gameData.CurrentAction}

                executeAction={() => executeAction()}
                applyHeroAction={applyHeroAction}
                addPlayerToSelection={addPlayerToSelection}
              />
            </div>
          )}
        </Grid.Column>
        <Grid.Column style={{ margin: 'auto' }}>
          <HeroPoolSection />
          <CardTable />
        </Grid.Column>
      </Grid>
      <div className="action-menu-padder" />
    </>
  )
}

export default FFABody;
